import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileCRM, Upload } from 'src/common/services/goinfre/file.model';
import { GoinfreService } from 'src/common/services/goinfre/goinfre.service';
import { MainItem } from 'src/common/services/main/main.model';


@Component({
  selector: 'upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent {

  dropzoneActive: boolean = false;
  currentUpload: Upload;


  
  @Input()
  item: MainItem;

  @Input()
  fileRecord: any;

  @Input()
  config: { path: string, filename: string };


  @Input()
  title: string = null;

  @Output() newImage: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public goinfre: GoinfreService,
  ) {
  }

  dropzoneState($event: boolean) {
    this.dropzoneActive = $event;
  }

  handleDrop(file: File) {
    if (file && file[0]) {
      this.currentUpload = new Upload(file[0], this.config.path, this.config.filename);
      this.goinfre.pushUpload(this.currentUpload, 'image', this.item).then((fileUploaded) => {
        if (this.fileRecord){
          // this.goinfre.deleteFileUpload(this.fileRecord);
        }
        this.fileRecord = fileUploaded;
        this.newImage.emit(fileUploaded);
        console.log(fileUploaded);
      });
    }
  }
}
